import { create } from "zustand";

export const useOrderStore = create((set, get) => ({
  orders: [],
  updateVersion: 0, // 🔥 UI re-render trigger

 setInitialOrders: (orders) => {
    // console.log(`📦 Setting initial fresh ${orders.length} orders`);

    const normalized = orders.map((o) => ({
      ...o,
      order_id: String(o.order_id),  // normalize id
    }));

    set({
      orders: normalized,
      updateVersion: get().updateVersion + 1,
    });
  },


  addOrUpdateOrder: (order) =>
    set((state) => {
      const incomingOrder = {
        ...order,
        order_id: String(order.order_id),
      };

      const idx = state.orders.findIndex(
        (o) => String(o.order_id) === incomingOrder.order_id
      );

      let newOrders;

      if (idx !== -1) {
        const oldOrder = state.orders[idx];

  

        newOrders = [...state.orders];
        newOrders[idx] = {
          ...newOrders[idx],
          ...incomingOrder,
        };
      } else {
     

        newOrders = [...state.orders, incomingOrder];
      }

      return {
        orders: newOrders,
        updateVersion: state.updateVersion + 1,
      };
    }),

  removeOrder: (order_id) =>
    set((state) => {
      const id = String(order_id);
      const exists = state.orders.find((o) => String(o.order_id) === id);



      return {
        orders: state.orders.filter((o) => String(o.order_id) !== id),
        updateVersion: state.updateVersion + 1,
      };
    }),
}));
